<ng-container *ngIf="introductionClicked">
    <div class="web-view">
        <div class="main-div">
            <div class="step">
                <button class="steps1">STEP 1</button>
                <button class="steps">STEP 2</button>
                <button class="steps">STEP 3</button>
            </div>
            <div class="d-flex row">
                <form>
                    <h1 class="heading" style="margin-top:-1%">Welcome to the "I Am Video" tool!</h1>
                    <p style="margin-top:1%">
                        <span class="textiamvideo">
                            Showcase some fun-facts to the Creatics community with your “I Am Video.”
                            In the following three easy steps, you will be prompted to upload pictures, videos,
                            and descriptive words about yourself. We'll do the rest.
                            Your personalized “I Am Video” will share your story much more than a profile picture. Click
                            below to watch a sample “I Am Video.”
                        </span>
                    </p>
                    <div class="items-center" style="width:100%;">
                        <iframe width="560" height="315"
                            src="https://www.youtube-nocookie.com/embed/yqYWe8mTNZM?rel=0&modestbranding=1&showinfo=0&fs=0&controls=0&autohid=1"
                            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
                             gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>

                    <h1 class="heading" style="margin-top:1%">STEP 1: INTRO</h1>

                    <div fxLayout="row">
                        <p class="step-heading"> <span style="font-weight:600">STEP 1:</span>
                            <span class="textiamvideo">
                                Introduce yourself! Please upload either 
1) a short video (9 seconds will be used, and we 
provide a trimmer) or 2) three images that you 
would like to be at the start of your “I Am” video. 
This first section will appear with the text “I Am...” 
overlayed on top, so be sure to show/tell who you 
are! It can be silent or you can say something to 
the camera.
                            </span>
                        </p>
                        <p style="margin: 0% 6%; font-size:18px">Horizontal videos/images are preferred.</p>

                    </div>
                    <div fxLayout="column wrap" class="description-div">

                        <div>
                            <h1 class="overLayText" id="overlay">UPLOAD VIDEO OR UPLOAD IMAGES</h1>

                        </div>



                        <div class="items-center">
                            <div class="videoIntro" [ngClass]="videoBoxDisable ? 'videoIntro' : 'uncheckedClass'"
                                (click)="video1.click();enableNextStep1()">

                                <figure>
                                    <input [disabled]="video1flag" class="form-control" type="file" (change)="onSelectFile($event,'video1'); onSelectVideo($event,'video1',9);enableNextStep1();
                                        " accept="video/mp4,video/x-m4v,video/*" #video1>

                                    <video [src]="url13" *ngIf="format13==='video' && url13" height="100%" width="100%"
                                        controls></video>
                                    <br>
                                    <div class="text-center">
                                        <img *ngIf="iconDisabled9" src="assets\images\Iamvideo\video icon.svg"
                                            height="">
                                    </div>

                                    <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled9"> Upload Video<br>
                                        The expected video duration is 9 seconds.
                                    </figcaption>
                                </figure>


                            </div>
                        </div>

                        <div class="cropButtonDiv" *ngIf="url13">

                            <button class="trimButton" data-bs-toggle="modal" data-bs-target="#myModal"
                                data-backdrop="false" [disabled]="trimVideo1Enable"
                                [ngStyle]="(!trimVideo1Enable) ?   {'cursor' :'pointer'}:{'cursor': 'not-allowed'}"
                                (click)="trimVideo('video1');openModalTrim()" data-backdrop="static"> Trim
                                Video</button>
                            <button class="trimButton" *ngIf="video1flag" (click)="video1.click();"> <input
                                    class="form-control" type="file"
                                    (change)="onSelectFile($event,'video1');onSelectVideo($event,'video1',9)"
                                    accept="video/mp4,video/x-m4v,video/*" #video1>Change Video
                            </button>
                        </div>

                        <p class="heading2">Accepted video file formats: mp4, mov.</p>
                        <p class="heading2"> Note: Please click “trim” button after uploading the video..</p>

                        <h1 class="overLayText" id="or">OR</h1>

                        <div fxLayout="row wrap" class="imgUpload-section1">
                            <div class="imgUpload" [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
                                (click)="image1.click();click1()" accept="image/*">
                                <div class="align-center">
                                    <image-cropper *ngIf="stopCropper1" [imageChangedEvent]="imageChangedEvent1"
                                        [maintainAspectRatio]="true"
                                        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4 / 3"
                                        [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                        [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                                        [style.display]="showCropper1 ? null : 'none'" format="png"
                                        (imageCropped)="imageCropped($event,'image1')"
                                        (imageLoaded)="imageLoaded('image1')">
                                    </image-cropper>


                                    <figure input type="file" accept="image/*">
                                        <input [disabled]="image1flag" class="form-control" type="file"
                                            (change)="onSelectFile($event,'image1')" accept="image/*" #image1>
                                        <div class="text-center">
                                            <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled1"
                                                height="50">
                                        </div>

                                        <figcaption class="vdocaption" *ngIf="iconDisabled1"> Upload Image<br>
                                            The expected image resolution is (500x500)
                                        </figcaption>


                                    </figure>
                                    <app-loader *ngIf="loaderImage1"
                                        style="font-family: 'Lato';font-size: 18px;color: #DF5535;">Please wait
                                    </app-loader>
                                    <img class="imgClass" [src]="image1url" *ngIf="format1==='image' && url1"
                                        height="10%"> <br>

                                    <button class="imagecropbtn" *ngIf="showCropButton1" [disabled]="cropbutton1"
                                        [ngStyle]="{ 'cursor':(cropbutton1)?'not-allowed':'pointer'}"
                                        (click)="cropImage('image1');clicked1 = true;" type="button"
                                        [ngStyle]="(clicked1) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton1) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">Crop
                                        Image</button>


                                </div>




                            </div>

                            <div fxLayout="row wrap" class="imgUpload"
                                [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
                                [ngClass]="image2Box ? 'imgUpload' : 'uncheckedClass'"
                                (click)="image2.click();enableNextStep1();click2()" accept="image/*">
                                <div class="align-center">
                                    <image-cropper *ngIf="stopCropper2" [imageChangedEvent]="imageChangedEvent2"
                                        [maintainAspectRatio]="true"
                                        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4 / 3"
                                        [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                        [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                                        [style.display]="showCropper2 ? null : 'none'" format="png"
                                        (imageCropped)="imageCropped($event,'image2')"
                                        (imageLoaded)="imageLoaded('image2')">
                                    </image-cropper>


                                    <figure input type="file" accept="image/*">
                                        <input class="form-control" [disabled]="image2flag" type="file"
                                            (change)="onSelectFile($event,'image2')" accept="image/*" #image2>
                                        <div class="text-center">
                                            <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled2"
                                                height="50">
                                        </div>
                                        <figcaption class="vdocaption" *ngIf="iconDisabled2"> Upload Image<br>
                                            The expected image resolution is (500x500)

                                        </figcaption>

                                    </figure>
                                    <app-loader *ngIf="loaderImage2"
                                        style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                    </app-loader>
                                    <img class="imgClass" [src]="image2url" *ngIf="format2==='image' && url2"
                                        height="10%"> <br>
                                    <button class="imagecropbtn" *ngIf="showCropButton2" type="button"
                                        [disabled]="cropbutton2" (click)="cropImage('image2');clicked2 = true;"
                                        type="button"
                                        [ngStyle]="(clicked2) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton2) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">Crop
                                        Image</button>

                                </div>
                            </div>

                            <div fxLayout="row wrap" class="imgUpload"
                                [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
                                [ngClass]="image3Box ? 'imgUpload' : 'uncheckedClass'"
                                (click)="image3.click();click3();enableNextStep1(); " accept="image/*">
                                <div class="align-center">
                                    <image-cropper *ngIf="stopCropper3" [imageChangedEvent]="imageChangedEvent3"
                                        [maintainAspectRatio]="true"
                                        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4 / 3"
                                        [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                        [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                                        [style.display]="showCropper3 ? null : 'none'" format="jpeg"
                                        (imageCropped)="imageCropped($event,'image3')"
                                        (imageLoaded)="imageLoaded('image3')">
                                    </image-cropper>


                                    <figure input type="file" accept="image/*">
                                        <input class="form-control" [disabled]="image3flag" type="file"
                                            (change)="onSelectFile($event,'image3')" accept="image/*" #image3>
                                        <div class="text-center">
                                            <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled3"
                                                height="50">
                                            <figcaption class="vdocaption" *ngIf="iconDisabled3"> Upload Image<br>
                                                The expected image resolution is (500x500)

                                            </figcaption>
                                        </div>




                                    </figure>
                                    <app-loader *ngIf="loaderImage3"
                                        style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                    </app-loader>
                                    <img class="imgClass" [src]="image3url" *ngIf="format3==='image' && url3"
                                        height="10%"> <br>
                                    <button class="imagecropbtn" *ngIf="showCropButton3" type="button"
                                        [disabled]="cropbutton3" (click)="cropImage('image3');clicked3 = true;"
                                        [ngStyle]="(clicked3) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton3) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">Crop
                                        Image</button>

                                </div>

                            </div>



                        </div>
                        <div class="stepChangeImage">

                            <button *ngIf="image1flag" class="trimButton3"
                                (click)="image1.click();click1();enableNextStep1();disable()">
                                <input class="form-control" type="file" (change)="onSelectFile($event,'image1')"
                                    accept="image/*" #image1>
                                Change Image
                            </button>

                            <button *ngIf="image2flag" class="trimButton4"
                                (click)="image2.click();click2();enableNextStep1();disable()">
                                <input class="form-control" type="file" (change)="onSelectFile($event,'image2')"
                                    accept="image/*" #image2>
                                Change Image
                            </button>

                            <button *ngIf="image3flag" class="trimButton5"
                                (click)="image3.click();click3();enableNextStep1();disable()">
                                <input class="form-control" type="file" (change)="onSelectFile($event,'image3')"
                                    accept="image/*" #image3>
                                Change Image
                            </button>
                        </div>
                    </div>
                </form>

            </div>
            <p class="heading2">Accepted image file formats: jpg, png.</p>
            <p class="heading2">Note: Please click “crop” button after uploading each image.</p>

            <div class="col-12 text-center">
                <button class="buttons" [ngStyle]="{'cursor':(nextButtonImage)?'not-allowed':'pointer'}"
                    [disabled]="nextButtonImage" (click)="btn1()" id="upload"> NEXT</button>
                <button class="buttons" id="clear" [ngStyle]="{'cursor':(clearBtn1)?'not-allowed':'pointer'}"
                    [disabled]="clearBtn1" (click)="onClear1()"> CLEAR</button>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="bodyClicked">
    <div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>

        <div class="main-div">

            <div class="align-center">
                <div class="step">
                    <button class="steps">STEP 1</button>
                    <button class="steps2">STEP 2</button>
                    <button class="steps">STEP 3</button>
                </div>
                <div class="col-12 text-center">

                    <form>
                        <h1 class="heading" style="color: #ea0404b8;margin-top:-1%;margin-bottom: 1%;">STEP 2: BODY</h1>
                        <p style="margin: 0% 6% 1%; font-size:18px; text-align: justify;"><span
                                style="font-weight:600">STEP 2:</span>Now, tell us more about yourself, and this will create the main
                                body of your “I Am Video”. Please follow the prompts and upload the 
                                accompanying images or videos.<br>
                            
                        <p style=" font-size:18px;text-align: justify;margin-top:1%;margin-bottom: 1%;">Horizontal
                            videos/images are preferred.</p>


                        <div class="items-left">
                            <button class="stepsBack" style="margin: 0% 0% 1% 0%;background-color: #DF5535;"
                                (click)="onBackClick()"> Back </button>
                        </div>
                        <div class="col-12">
                            <div style="margin-bottom:2%;text-align: center;padding-inline-start: 12%;">
                                <div style="display: flex; flex-direction:row">
                                    <li>A</li>
                                    <label for="city">
                                        Please upload an image of your hometown or favorite city
                                        and then tell us about it in the text pop-up.
                                    </label>
                                </div>
                                <div class="video" (click)="image4.click();click4()">
                                    <div class="align-center">
                                        <image-cropper *ngIf='stopCropper4' [imageChangedEvent]="imageChangedEvent4"
                                            [maintainAspectRatio]="true"
                                            [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4/3"
                                            [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                            [canvasRotation]="canvasRotation" [transform]="transform"
                                            [alignImage]="'left'" [style.display]="showCropper4 ? null : 'none'"
                                            format="png" (imageCropped)="imageCropped($event,'image4')"
                                            (imageLoaded)="imageLoaded('image4')">
                                        </image-cropper>

                                        <figure input type="file" accept="image/*">
                                            <input class="form-control" [disabled]="image4flag" type="file"
                                                accept="image/*" (change)="onSelectFile($event,'image4')" #image4>

                                            <div class="items-center">
                                                <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled4"
                                                    height="50">
                                            </div>

                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled4">Upload
                                                Image of town/city<br>
                                                The expected image resolution is (500x500)
                                            </figcaption>

                                        </figure>
                                        <app-loader *ngIf="loaderImage4"
                                            style="font-family: 'Lato';font-size: 18px;color:  #DF5535;">Please wait
                                        </app-loader>
                                        <span *ngIf="image4Text">{{image4Text}}</span>
                                        <img class="imgClass" [src]="image4url" *ngIf="format4==='image' && url4"
                                            height="10%"> <br>

                                        <button class="imagecropbtn" *ngIf="showCropButton4" type="button"
                                            [disabled]="cropbutton4" (click)="clicked4 = true;openModal4();disable2()"
                                            [ngStyle]="(clicked4) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton4) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">
                                            Describe and Crop Image</button>

                                    </div>



                                </div>
                                <div class="align-center">
                                    <button *ngIf="image4flag" style="margin: 0% 14% 1% 0%;" class="trimButton"
                                        (click)="image4.click();click4()">
                                        <input class="form-control" type="file" (change)="onSelectFile($event,'image4')"
                                            accept="image/*" #image4>
                                        Change Image
                                    </button>
                                </div>
                                <div style="margin-left:-10%;">
                                    <p class="heading2">Accepted image file formats: jpg, png.</p>
                                    <p class="heading2">Note: Please click “crop” button after uploading each image.</p>
                                </div>

                            </div>


                            <div style="margin-bottom: 2%;text-align: start;padding-inline-start: 12%;">
                                <div style="display:flex ;flex-direction:row">
                                    <li>B</li>
                                    <label>
                                        Please upload an image of your favorite food, beverage, or
                                        cuisine and then tell us about it in the text pop-up.
                                    </label>
                                </div>


                                <div class="video" (click)="image5.click();click5()">
                                    <div class="align-center">
                                        <image-cropper *ngIf='stopCropper5' [imageChangedEvent]="imageChangedEvent5"
                                            [maintainAspectRatio]="true"
                                            [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4/3"
                                            [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                            [canvasRotation]="canvasRotation" [transform]="transform"
                                            [alignImage]="'left'" [style.display]="showCropper5 ? null : 'none'"
                                            format="png" (imageCropped)="imageCropped($event,'image5')"
                                            (imageLoaded)="imageLoaded('image5')">
                                        </image-cropper>


                                        <figure input type="file" accept="image/*">
                                            <input class="form-control" [disabled]="image5flag" type="file"
                                                accept="image/*" (change)="onSelectFile($event,'image5')" #image5>

                                            <div class="items-center">
                                                <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled5"
                                                    height="50">
                                            </div>
                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled5"> Upload
                                                Image of food/drink below
                                                <br>
                                                The expected image resolution is (500x500)
                                            </figcaption>


                                        </figure>
                                        <app-loader *ngIf="loaderImage5"
                                            style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                        </app-loader>
                                        <span *ngIf="image5Text">{{image5Text}}</span>

                                        <img class="imgClass" [src]="image5url" *ngIf="format5==='image' && url5"
                                            height="10%"> <br>
                                        <button class="imagecropbtn" *ngIf="showCropButton5" type="button"
                                            data-toggle="modal" data-target="#myModal" [disabled]="cropbutton5"
                                            (click)="cropImage('image5');clicked5 = true;" (click)="openModal5()"
                                            [ngStyle]="(clicked5) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton5) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">
                                            Describe and Crop Image</button>


                                    </div>

                                </div>
                                <div class="align-center">
                                    <button *ngIf="image5flag" style="margin: 0% 14% 1% 0%;" class="trimButton"
                                        (click)="image5.click();click5();disable2()">
                                        <input class="form-control" type="file" (change)="onSelectFile($event,'image5')"
                                            accept="image/*" #image5>
                                        Change Image
                                    </button>
                                </div>
                                <div style="margin-left:-10%;">
                                    <p class="heading2">Accepted image file formats: jpg, png.</p>
                                    <p class="heading2">Note: Please click “crop” button after uploading each image.</p>

                                </div>

                            </div>

                            <div style="margin-bottom: 2% ; text-align: start;padding-inline-start: 12%;">
                                <div style="display:flex ;flex-direction:row">
                                    <li>C</li>
                                    <label>
                                        Please upload an image of your favorite book, movie, or
                                        franchise and then tell us about it in the text pop-up.
                                    </label>
                                </div>


                                <div class="video" (click)="image6.click();click6()">
                                    <div class="align-center">
                                        <image-cropper *ngIf="stopCropper6" [imageChangedEvent]="imageChangedEvent6"
                                            [maintainAspectRatio]="true"
                                            [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4/3"
                                            [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                            [canvasRotation]="canvasRotation" [transform]="transform"
                                            [alignImage]="'left'" [style.display]="showCropper6 ? null : 'none'"
                                            format="png" (imageCropped)="imageCropped($event,'image6')"
                                            (imageLoaded)="imageLoaded('image6')">
                                        </image-cropper>
                                        <figure input type="file" accept="image/*">
                                            <input class="form-control" [disabled]="image6flag" type="file"
                                                accept="image/*" (change)="onSelectFile($event,'image6')" #image6>
                                            <div class="items-center">
                                                <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled6"
                                                    height="50">
                                            </div>
                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled6"> Upload
                                                Image of book/movie/franchise
                                                <br>
                                                The expected image resolution is (500x500)
                                            </figcaption>
                                        </figure>
                                        <app-loader *ngIf="loaderImage6"
                                            style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                        </app-loader>
                                        <span *ngIf="image6Text">{{image6Text}}</span>

                                        <img class="imgClass" [src]="image6url" *ngIf="format6 ==='image' && url6"
                                            height="10%">
                                        <br>
                                        <button class="imagecropbtn" *ngIf="showCropButton6" type="button"
                                            data-toggle="modal" data-target="#myModal" [disabled]="cropbutton6"
                                            (click)="cropImage('image6');clicked6 = true;openModal6()"
                                            [ngStyle]="(clicked6) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton6) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">
                                            Describe and Crop Image</button>


                                    </div>

                                </div>
                                <div class="align-center">

                                    <button *ngIf="image6flag" style="margin: 0% 14% 1% 0%;" class="trimButton"
                                        (click)="image6.click();click6();disable2()">
                                        <input class="form-control" type="file" (change)="onSelectFile($event,'image6')"
                                            accept="image/*" #image6>
                                        Change Image
                                    </button>
                                </div>
                                <div style="margin-left:-10%;">
                                    <p class="heading2">Accepted image file formats: jpg, png.</p>
                                    <p class="heading2">Note: Please click “crop” button after uploading each image.</p>

                                </div>

                            </div>
                            <div style="margin-bottom: 2%;text-align: start;padding-inline-start: 12%;">
                                <div style="display: flex; flex-direction:row">
                                    <li>D</li>
                                    <label>
                                        Please upload an image of your favorite hobby and then tell
                                        us about it in the text pop-up.
                                    </label>
                                </div>


                                <div class="video" (click)="image7.click();click7()">
                                    <div class="align-center">
                                        <image-cropper *ngIf="stopCropper7" [imageChangedEvent]="imageChangedEvent7"
                                            [maintainAspectRatio]="true"
                                            [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4/3"
                                            [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                            [canvasRotation]="canvasRotation" [transform]="transform"
                                            [alignImage]="'left'" [style.display]="showCropper7 ? null : 'none'"
                                            format="png" (imageCropped)="imageCropped($event,'image7')"
                                            (imageLoaded)="imageLoaded('image7')">
                                        </image-cropper>

                                        <figure input type="file" accept="image/*">
                                            <input class="form-control" [disabled]="image7flag" type="file"
                                                accept="image/*" (change)="onSelectFile($event,'image7')" #image7>

                                            <div class="items-center">
                                                <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled7"
                                                    height="50">
                                            </div>
                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled7"> Upload
                                                Image of hobby
                                                <br>
                                                The expected image resolution is (500x500)
                                            </figcaption>

                                        </figure>
                                        <app-loader *ngIf="loaderImage7"
                                            style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                        </app-loader>
                                        <span *ngIf="image7Text">{{image7Text}}</span>

                                        <img class="imgClass" [src]="image7url" *ngIf="format7==='image' && url7"
                                            height="10%"><br>

                                        <button class="imagecropbtn" *ngIf="showCropButton7" type="button" type="button"
                                            data-toggle="modal" data-target="#myModal" [disabled]="cropbutton7"
                                            (click)="cropImage('image7');clicked7 = true;" (click)="openModal7()"
                                            [ngStyle]="(clicked7) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton7) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">
                                            Describe and Crop Image</button>

                                    </div>


                                </div>
                                <div class="align-center">
                                    <button *ngIf="image7flag" style="margin: 0% 14% 1% 0%;" class="trimButton"
                                        (click)="image7.click();click7();disable2()">
                                        <input class="form-control" type="file" (change)="onSelectFile($event,'image7')"
                                            accept="image/*" #image7>
                                        Change Image
                                    </button>
                                </div>
                                <div style="margin-left:-10%;">
                                    <p class="heading2">Accepted image file formats: jpg, png.</p>
                                    <p class="heading2">Note: Please click “crop” button after uploading each image.</p>

                                </div>

                                <div style="margin-top: 2%; text-align: start;">
                                    <div style="display:flex; flex-direction:row">
                                        <li>E</li>
                                        <label>
                                            Now, please upload a short video of anything you are
                                            passionate about and then tell us about it in the text pop-up.
                                        </label>
                                    </div>

                                    <div class="video" (click)="video2.click();">

                                        <figure>
                                            <input class="form-control" [disabled]="video2flag" type="file"
                                                (change)="onSelectVideo($event,'video2',4);onSelectFile($event,'video2')"
                                                accept="video/mp4,video/x-m4v,video/*" #video2>
                                            <span *ngIf="video2Text" style="margin-left: 43%;">{{video2Text}}</span>

                                            <video [src]="url8" *ngIf="format8==='video' && url8" height="300"
                                                width="400" controls></video>
                                            <br>
                                            <div class="items-center">
                                                <img *ngIf="iconDisabled10" src="assets\images\Iamvideo\video icon.svg">
                                            </div>

                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled10"> Upload
                                                video of passion
                                                <br>
                                                The expected video duration is 4 seconds
                                            </figcaption>

                                        </figure>
                                    </div>
                                    <div class="cropButtonDiv" *ngIf="url8">
                                        <button class="trimButton1" style="margin:1% 3% 1% -10%;"
                                            [disabled]="trimVideo2Enable"
                                            [ngStyle]="(!trimVideo2Enable) ?   {'cursor' :'pointer'}:{'cursor': 'not-allowed'}"
                                            (click)="trimVideo('video2');openModal8()">Describe and Trim Video </button>
                                        <button *ngIf="video2flag" class="trimButton1" (click)="video2.click();go()">
                                            <input class="form-control" type="file"
                                                (change)="onSelectFile($event,'video2');onSelectVideo($event,'video2',4);"
                                                accept="video/mp4,video/x-m4v,video/*" #video2>
                                            Change Video
                                        </button>
                                    </div>

                                    <div style="margin-left:-10%;">
                                        <p class="heading2">Accepted video file formats: mp4, mov.</p>
                                        <p class="heading2">Note : Please click "trim" button after uploading the video
                                        </p>
                                    </div>

                                </div>

                                <div style="margin-top: 2%;text-align: start;">
                                    <div style="display:flex; flex-direction:row">
                                        <li>F</li>
                                        <label>
                                            Finally, please upload another short video of anything you are
                                            passionate about and then tell us about it in the text pop-up.
                                        </label>
                                    </div>


                                    <div class="video" (click)="video3.click();">
                                        <figure>
                                            <input class="form-control" [disabled]="video3flag" type="file"
                                                accept="video/mp4,video/x-m4v,video/*"
                                                (change)="onSelectFile($event,'video3');onSelectVideo($event,'video3',4)"
                                                #video3>
                                            <span *ngIf="video3Text" style="margin-left: 43%;">{{video3Text}}</span>

                                            <video [src]="url9" *ngIf="format9==='video' && url9" height="300"
                                                width="400" controls></video>

                                            <div class="items-center">
                                                <img *ngIf="iconDisabled11" src="assets\images\Iamvideo\video icon.svg">
                                            </div>
                                            <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled11"> Upload
                                                video of passion
                                                <br>
                                                The expected video duration is 4 seconds
                                            </figcaption>

                                        </figure>
                                    </div>
                                    <div class="cropButtonDiv">
                                        <button *ngIf="url9" style="margin:1% 3% 1% -10%;" class="trimButton1"
                                            [disabled]="trimVideo3Enable"
                                            [ngStyle]="(!trimVideo3Enable) ?   {'cursor' :'pointer'}:{'cursor': 'not-allowed'}"
                                            (click)="trimVideo('video3');openModal9()">Describe and Trim Video </button>

                                        <button *ngIf="video3flag" class="trimButton1" (click)="video3.click();go()">
                                            <input class="form-control" type="file"
                                                accept="video/mp4,video/x-m4v,video/*"
                                                (change)="onSelectFile($event,'video3');onSelectVideo($event,'video3',4)"
                                                #video3>
                                            Change Video
                                        </button>
                                    </div>
                                    <div style="margin-left:-10%;">
                                        <p class="heading2">Accepted video file formats: mp4, mov.</p>
                                        <p class="heading2">Note : Please click "trim" button after uploading the video
                                        </p>
                                    </div>
                                </div>



                            </div>
                        </div>
                        <div class="items-center">
                            <button class="buttons" id="upload" [disabled]="btnNextEnabled"
                                [ngStyle]="{ 'cursor':(btnNextEnabled)?'not-allowed':'pointer'}"
                                (click)="btn2()">NEXT</button>
                            <button class="buttons" id="clear"
                                [ngStyle]="{'cursor':(clearBtn2)?'not-allowed':'pointer'}" [disabled]="clearBtn2"
                                (click)="onClear2()"> CLEAR</button>
                        </div>
                    </form>





                </div>
            </div>

        </div>

    </div>
</ng-container>
<ng-container *ngIf="conclusionClicked">

    <div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>

        <div class="main-div" fxLayout="row wrap">


            <div class="step">

                <button class="steps">STEP 1</button>
                <button class="steps">STEP 2</button>
                <button class="steps3">STEP 3</button>
            </div>
            <form>
                <div class="col-12">
                    <h1 class="heading" style="color: #ea0404b8;margin-top:-1%">STEP 3: CONCLUSION</h1>
                    <p style="margin: 1% 6% 1%; font-size:20px"><span style="font-weight:600">STEP 3:</span> This
                        section concludes your “I Am
                        Video”. Please upload a photo and short video
                        that you speaks to who you are and you will
                        be asked to enter your preferred name.
                    </p>

                    <p style="margin: 1% 6%; font-size:20px">Horizontal videos/images are preferred.</p>
                    <div class="items-center">
                        <button class="stepsBack" style="margin: 0% 0% 0% 0%;background-color:#DF5535;"
                            (click)="onBackClick2()"> Back</button>
                    </div>
                    <div fxLayout="column wrap" class="description-div">

                        <div style="margin-bottom: 2%;">

                            <div style="margin-bottom: 2%;justify-content: center;">
                                <h1 class="overLayText" id="overlay">Overlay Text:</h1>
                                <h1 class="overLayText">"I Am(Name)"</h1>
                            </div>


                            <div class="videoConclusion" (click)="video4.click();enableUpload()">
                                <figure>
                                    <input class="form-control" [disabled]="video4flag" type="file"
                                        accept="video/mp4,video/x-m4v,video/*" (change)="onSelectVideo($event,'video4',4);enableUpload();
                                            onSelectFile($event,'video4')" #video4>
                                    <!-- <span *ngIf="video4Text">{{video4Text}}</span> -->

                                    <video [src]="url10" *ngIf="format10 ==='video' && url10" height="300" width="400"
                                        controls></video>


                                    <div class="items-center">
                                        <img *ngIf="iconDisabled12" src="assets\images\Iamvideo\video icon.svg">
                                    </div>

                                    <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled12"> Upload Video
                                        <br>
                                        The expected video duration is 4 seconds

                                    </figcaption>

                                </figure>


                            </div>
                            <div class="cropButtonDiv">
                                <button *ngIf="url10" class="trimButton2" data-bs-toggle="modal"
                                    data-bs-target="#myModal" data-backdrop="false" [disabled]="trimVideo4Enable"
                                    [ngStyle]="(!trimVideo4Enable) ?   {'cursor' :'pointer'}:{'cursor': 'not-allowed'}"
                                    (click)="trimVideo('video4');openModalTrim()">Trim Video</button>

                                <button *ngIf="video4flag" class="trimButton2" (click)="video4.click();enableUpload()">
                                    <input class="form-control" type="file" accept="video/mp4,video/x-m4v,video/*"
                                        (change)="onSelectVideo($event,'video4',4);
                                            onSelectFile($event,'video4')" #video4>
                                    Change Video </button>
                            </div>

                            <p class="heading2">Accepted video file formats: mp4, mov.</p>
                            <p class="heading2">Note : Please click "trim" button after uploading the video</p>
                        </div>


                        <div style="margin-bottom: 2%;">



                            <div class="videoConclusion" (click)="image8.click();click8();enableUpload()">
                                <div class="align-center">
                                    <image-cropper [imageChangedEvent]="imageChangedEvent8" [maintainAspectRatio]="true"
                                        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4/3"
                                        [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                        [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                                        [style.display]="showCropper8 ? null : 'none'" format="png"
                                        (imageCropped)="imageCropped($event,'image8')"
                                        (imageLoaded)="imageLoaded('image8')">
                                    </image-cropper>

                                    <figure input type="file" accept="image/*">
                                        <input class="form-control" [disabled]="image8flag" type="file" accept="image/*"
                                            (change)="onSelectFile($event,'image8')" #image8>
                                        <div class="items-center">
                                            <img src="assets\images\Iamvideo\photo icon.svg" *ngIf="iconDisabled8"
                                                height="50">
                                        </div>

                                        <figcaption class="vdocaption" id="vdoCap" *ngIf="iconDisabled8"> Upload Your
                                            Image
                                            <br>
                                            The expected image resolution is (500x500)

                                        </figcaption>
                                    </figure>

                                    <app-loader *ngIf="loaderImage8"
                                        style="font-family: 'Lato';font-size: 18px;color: #DF5535;;">Please wait
                                    </app-loader>
                                    <span *ngIf="image8Text">{{image8Text}}</span>

                                    <img class="imgClass" [src]="image8url" *ngIf="format12==='image' && url12"
                                        height="10%"><br>

                                    <button class="imagecropbtn" *ngIf="showCropButton8" type="button" type="button"
                                        data-toggle="modal" data-target="#myModal" [disabled]="cropbutton8"
                                        (click)="cropImage('image8');clicked8 = true;" (click)="openModal10()"
                                        [ngStyle]="(clicked8) ? {'visibility': 'hidden'} : {'visibility': 'visible'}&&(cropbutton8) ? {'cursor': 'not-allowed'} : {'cursor' :'pointer'}">
                                        Describe and Crop Image</button>


                                </div>

                            </div>
                            <div class="align-center">
                                <button *ngIf="image8flag" style="margin: 0% 0% 1% 0%;" class="trimButton"
                                    (click)="image8.click();click8();enableUpload();">
                                    <input class="form-control" type="file" (change)="onSelectFile($event,'image8')"
                                        accept="image/*" #image8>
                                    Change Image
                                </button>
                            </div>
                            <p class="heading2">Accepted image file formats: jpg, png.</p>
                            <p class="heading2">Note: Please click “crop” button after uploading each image.</p>
                        </div>

                        <div>
                            <div class="col-12 text-center">
                                <button class="buttons" id="upload" style="margin: 0% 2% 3% 2%;font-size:14px"
                                    [ngStyle]="{'cursor':(btnUploadEnable)?'not-allowed':'pointer'}"
                                    [disabled]="btnUploadEnable && uploadClicked" (click)="btn3()">Make My Video</button>
                                <button class="buttons" id="clear" style="margin: 0% 2% 3% 2%;"
                                    [ngStyle]="{'cursor':(clearBtn3)?'not-allowed':'pointer'}" [disabled]="clearBtn3"
                                    (click)="onClear3()">CLEAR</button>
                            </div>


                            <div>
                                <app-loader *ngIf="loading"
                                    style="font-family: 'Lato';font-size: 18px;color: #DF5535;margin-bottom:2%;">Please
                                    wait
                                </app-loader>
                                <p  *ngIf="loading" style=" color: #DF5535;   font-size: 20px;
                                text-align: center;
                                margin: 0% 0% 3% 0%;">    After your I Am Video has finished compiling, it will be automatically loaded to your Profile. 
                                You can also change/edit the video here on this page and via back buttons if you choose.</p>
                                <ng-container *ngIf="urlAvailable">
                                    <div class="items-center">
                                        <video style="height: auto;
                                        width: 40%;
                                        " controls autoplay>
                                            <source [src]="videoUrl" />
                                        </video>
                                    </div>
                                    <p class="blink" style="font-size: 20px;
                                    text-align: center;
                                    margin: 1% 0% 3% 0%;">This Video Is Uploaded to Your Profile Section.</p>
                                    <p style=" color: #DF5535;   font-size: 20px;
 text-align: center;
 margin: 1% 0% 5% 0%;">To edit your video click on the Back button at the top of the page to change
                                        the videos or pictures of your choice. Click on Upload to view your edited
                                        video.</p>
                                </ng-container>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>




<!-- ................Modal................-->

<div class="modal" id="textModal" [ngStyle]="{'display':display}">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="background-color: #fff !important;">
            <div class="modal-header">
                <h4 *ngIf="croppedImage4" class="modal-title" style="color:black;font-size: 17px;">Enter name or briefly describe your favorite city: </h4>
                <h4 *ngIf="croppedImage5" class="modal-title" style="color:black;font-size: 17px;">Tell us about your
                    favorite food, beverage, or
                    cuisine:</h4>
                <h4 *ngIf="croppedImage6" class="modal-title" style="color:black;font-size: 17px;">Tell us about your favorite book, movie, tv, or franchise:                  </h4>
                <h4 *ngIf="croppedImage7" class="modal-title" style="color:black;font-size: 17px;">Tell us about your
                    favorite hobby:</h4>
                <h4 *ngIf="trimmedVideo2" class="modal-title" style="color:black;font-size: 17px;">Tell us about your
                    passion:</h4>
                <h4 *ngIf="trimmedVideo3" class="modal-title" style="color:black;font-size: 17px;">Tell us about your
                    passion:</h4>
                <h4 *ngIf="croppedImage8" class="modal-title" style="color:black;font-size: 17px;">Please tell us your
                    name:</h4>
            </div>
            <div *ngIf="croppedImage4" class="modal-body">
                <input type="text" placeholder="e.g. New York, Atlanta upto 18 characters" name="image4Text"
                    [(ngModel)]='image4Text' [ngModelOptions]="{standalone: true}" maxlength="18" required>
            </div>
            <div *ngIf="croppedImage5" class="modal-body">
                <input type="text" placeholder="e.g. french fries , mexican upto 18 characters" id="upload"
                    name="image5Text" maxlength="18" [(ngModel)]='image5Text' [ngModelOptions]="{standalone: true}">
            </div>
            <div *ngIf="croppedImage6" class="modal-body">
                <input type="text" placeholder="e.g. marvel , hamlet upto 18 characters" id="upload" name="image6Text"
                    maxlength="18" [(ngModel)]='image6Text' [ngModelOptions]="{standalone: true}">
            </div>
            <div *ngIf="croppedImage7" class="modal-body">
                <input type="text" placeholder="e.g. hiking, trekking upto 18 characters" id="upload" name="image7Text"
                    maxlength="18" [(ngModel)]='image7Text' [ngModelOptions]="{standalone: true}">
            </div>
            <div *ngIf="trimmedVideo2" class="modal-body">
                <input type="text" placeholder="e.g. travel,music upto 18 characters" id="upload" name="video2Text"
                    maxlength="18" [(ngModel)]='video2Text' [ngModelOptions]="{standalone: true}">
            </div>
            <div *ngIf="trimmedVideo3" class="modal-body">
                <input type="text" placeholder="e.g. painting, writing upto 18 characters" id="upload" name="video3Text"
                    maxlength="18" [(ngModel)]='video3Text' [ngModelOptions]="{standalone: true}">
            </div>
            <div *ngIf="croppedImage8" class="modal-body">
                <input type="text" placeholder="Name upto 18 characters" id="upload" name="image8Text"
                    [(ngModel)]='image8Text' maxlength="18" [ngModelOptions]="{standalone: true}">
            </div>

            <div *ngIf="croppedImage4" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!image4Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="croppedImage5" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!image5Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="croppedImage6" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!image6Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="croppedImage7" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!image7Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="trimmedVideo2" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!video2Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="trimmedVideo3" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!video3Text" (click)="onCloseTextModal()">Submit</button>
            </div>
            <div *ngIf="croppedImage8" class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="#textModal" data-bs-target="#myModal"
                    data-backdrop="false" [disabled]="!image8Text" (click)="onCloseTextModal()">Submit</button>
            </div>
        </div>
    </div>
</div>


<div *ngIf="trimClicked" class="modal" id="myModal" [ngStyle]="{'display':display1}">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="background-color: #fff !important;">
          
            <div class="modal-body">
               
                <h2 style="color:black;margin: 0% 0% 0% 30%;">Trim Your Video 
                    <button *ngIf="!trimmedVideoUrl" type="button" (click)="onCloseHandled()"
                    style="background-color: orangered;float:right;height: 2vh;
                    width: 5%;" class="btn-close" data-bs-dismiss="modal"
                    data-dismiss="modal"></button></h2>
               
               
                <app-loader *ngIf="trimCreateBtn" class="app-loader"
                    style="font-family: 'Lato';font-size: 18px;color: #DF5535;;z-index: 10;">Please wait
                </app-loader>
                <mat-progress-bar *ngIf='trimCreateBtn || loaderTrim' style="color:#DF5535"
                    mode="indeterminate"></mat-progress-bar>

                <p *ngIf='!trimCreateBtn' class="blink" style="margin:2% 3% 2%"> Select the start time to trim your video. If video is under a
                    minute, use the seconds box only.</p>
                <p *ngIf='trimCreateBtn' class="blink" style="margin:2% 3% 2%"> Wait for few seconds, your video is getting uploaded</p>
                <div *ngIf='!trimCreateBtn' class="progress-bar"
                    [ngStyle]="{ 'left': videoDuration + '%', 'width': end1 + '%' }"> Your video duration is
                    {{videoDuration}}seconds</div>

                <div class="row">
                    <div class="col">
                        <div>
                            <div>
                                <label id=start for="start1">
                                    Trim From
                                </label>
                                &nbsp;
                                <input *ngIf="hideMin" [disabled]="trimCreateBtn" class="input1" name="start1" type="number" min="0" max="30" step="1" pattern="[0-1]" placeholder="00"
                                    id="start" [value]="startMin" [(ngModel)]="startMin" (input)="onStartClick()"
                                    required>
                                <span *ngIf="hideMin"
                                    style="color:black; margin: 0% 1% 0% -2%;font-family: lato;">Min</span>

                                <input [ngStyle]="{ 'margin-left':(hideMin)?'0%':'9%'}" [disabled]="trimCreateBtn"
                                    class="input2" name="start1" type="number" min="0" max="60" step="1" pattern="[0-1]" placeholder="00"
                                    id="start" [value]="startSec" [(ngModel)]="startSec" (input)="onStartClick()"
                                    required>
                                <span
                                    style="color:black; margin: 0% 1% 0% -1%;font-family: lato;font-weight: 600;">Seconds</span>
                                <svg id="icon" xmlns="http://www.w3.org/2000/svg" height="48" width="48">
                                    <path d="M28 34 18 24l10-10Z" />
                                </svg>

                            </div>



                        </div>
                    </div>
                    <div>

                        <div *ngIf="video1trim">
                            <label style="color: black;margin: 5% 0% 5% 2%;;
                            background-color: white;" for="end1">
                                End Time [Fixed]
                            </label>
                            &nbsp; &nbsp;
                            <input style="color: black;
                            background-color: white;
                       width:20%;" type="text" id="end" [value]="end1" [(ngModel)]="end1" disabled />
                        </div>

                        <div *ngIf="video2trim">
                            <label style="color: black;margin:5% 0% 5% 2%;
                            background-color: white;" for="end1">
                                End Time [Fixed]
                            </label>
                            &nbsp; &nbsp;
                            <input style="color: black;
                            background-color: white;
                        margin:0% 0% 0% 0%;  width:20%;" type="text" id="end" [value]="end1" [(ngModel)]="end1"
                                disabled />
                        </div>
                        <div *ngIf="video3trim">
                            <label style="color: black;margin:5% 0% 5% 2%;
                            background-color: white; " for="end1">
                                End Time [Fixed]

                            </label>
                            &nbsp; &nbsp;
                            <input style="color: black;
                            background-color: white;  width:20%;
                        margin:0% 0% 0% 0%;" type="text" id="end" [value]="end1" disabled [(ngModel)]="end1" />
                        </div>
                        <div *ngIf="video4trim">
                            <label style="color: black;margin:5% 0% 5% 2%;
                            background-color: white;" for="end1">
                                End Time [Fixed]

                            </label>
                            &nbsp; &nbsp;
                            <input style="color: black;
                            background-color: white; width:20%;
                        margin:0% 0% 0% 0%;" type="text" id="end" [value]="end1" maxlength="3" disabled
                                [(ngModel)]="end1" />
                        </div>
                    </div>
                </div>

                <button type="submit" class="createVideo" id="submit-video"
                    [ngStyle]="{ 'cursor':(trimCreateBtn)?'not-allowed':'pointer'}" [disabled]="trimCreateBtn"
                    (click)="createvideo()">
                    Trim Video
                </button>
                <button *ngIf="trimmedVideoUrl" class="uploadandnext" data-bs-dismiss="#myModal" data-backdrop="false"
                    data-bs-dismiss="modal" data-dismiss="modal" (click)="backToUpload()">
                    Upload And Next</button>
                <p style="color:black; margin:2% 3% 2%">Enter the time for the start point of your video, and our tool will trim it to
                    the expected video duration. You can see the results and adjust if needed. You will be able to change the
                    video start times until you get it right. If your video is under a minute, use seconds box only..
                </p>




                <app-loader *ngIf="loaderTrim" class="app-loader"
                    style="font-family: 'Lato';font-size: 18px;color:#DF5535; ;z-index: 10;">Please wait
                </app-loader>

                <div>
                    <div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <p *ngIf="!trimmedVideoUrl" style="color: #DF5535;;margin-right:29%; "> You can watch your trimmed video
                    here...</p>

                    <video class="trimvdo" [src]="trimmedVideoUrl" *ngIf="trimmedVideoUrl" controls></video>

                <p *ngIf='trimmedVideoUrl' style="color:#DF5535;;">You can trim this video again by changing the start
                    time </p>


            </div>
        </div>
    </div>
</div>